import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_6 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/Timeline/TimelineItem.vue';
import __unplugin_components_5 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/ExtField.vue';
import __unplugin_components_4 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/Timeline/TimelineItem.vue';
import __unplugin_components_3 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/Timeline/TimelineItem.vue';
import __unplugin_components_2 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/Timeline/index.vue';
import __unplugin_components_1 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/UserLogo.vue';
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/UserLogo.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('view-box', {
    ref: "viewBox"
  }, [_c('div', {
    staticClass: "service-process"
  }, [_c('div', {
    staticClass: "person"
  }, [_c('div', {
    staticClass: "person-top"
  }, [_c('div', {
    staticClass: "person-top-text font-size-h3-large"
  }, [_vm._v(i18n.tc("434"))])]), _c('div', {
    staticClass: "person-center"
  }, [_c('div', {
    staticClass: "person-center-img"
  }, [_c(__unplugin_components_0, {
    attrs: {
      "size": 2,
      "url": _vm.orderInfo.visit_user_avatar,
      "name": _vm.orderInfo.visit_user_name,
      "show-border": "",
      "border-color": "#f8f8f8"
    }
  })], 1), _c('div', {
    staticClass: "person-center-text"
  }, [!_vm.$env.isWx ? _c('div', {
    staticClass: "person-center-text-name font-size-h3-normal"
  }, [_vm._v(" " + i18n.tc("617") + _vm._s(_vm.orderInfo.visit_user_name) + " ")]) : _vm._e(), _c('div', {
    staticClass: "person-center-text-phone font-size-h3-normalt"
  }, [_vm._v(" " + i18n.tc("531") + _vm._s(_vm.is_hide_worker_phone !== 1 ? _vm.orderInfo.visit_user_mobile || '' : '-') + " "), _vm.is_hide_worker_phone !== 1 && _vm.orderInfo.visit_user_mobile ? _c('a', {
    staticClass: "main-color customer-icon",
    attrs: {
      "href": "tel:" + _vm.orderInfo.visit_user_mobile
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/icon/tel24_24@3x.png")
    }
  })]) : _vm._e()])])]), _vm.coordList.length > 0 ? _c('div', {
    staticClass: "person-line"
  }) : _vm._e(), _vm.coordList.length > 0 ? _c('div', {
    staticClass: "person-bottom"
  }, [_c('div', {
    staticClass: "person-bottom-left"
  }, [_c('div', {
    staticClass: "person-bottom-img"
  }, _vm._l(_vm.coordList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "person-bottom-img-item",
      style: {
        'z-index': _vm.coordList.length - index
      }
    }, [_c(__unplugin_components_1, {
      attrs: {
        "size": 3,
        "url": item.avatar,
        "name": item.name,
        "show-border": "",
        "border-color": "#f8f8f8"
      }
    })], 1);
  }), 0), !_vm.$env.isWx ? _c('div', {
    staticClass: "person-bottom-text font-size-h3-normal smy__text-overflow-one-line",
    style: {
      marginLeft: _vm.coordListName ? 2 + 'rem' : ''
    }
  }, [_vm._v(" " + i18n.tc("618") + _vm._s(_vm.coordListName) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "person-bottom-right",
    on: {
      "click": function ($event) {
        _vm.show = true;
      }
    }
  }, [_c('div', {
    staticClass: "person-bottom-session"
  }, [_c('img', {
    staticClass: "person-bottom-session-img",
    attrs: {
      "src": "/spa_static_mobile/icon/more4_28@3x.png"
    }
  })])])]) : _vm._e()]), _vm.is_customer_view_progress === 1 ? [[0, 1, 2].indexOf(_vm.orderInfo.state) === -1 ? _c(__unplugin_components_2, {
    staticClass: "timeline",
    attrs: {
      "list": _vm.orderServiceNodes
    }
  }, [_c(__unplugin_components_3, {
    attrs: {
      "dash": _vm.orderServiceNodes.length !== 0 || _vm.orderInfo.state === 5
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(i18n.tc("619"))]), _c('div', {
    attrs: {
      "slot": "date"
    },
    slot: "date"
  }, [_vm._v(" " + _vm._s(_vm.orderInfo.sign_time1 || i18n.tc("620")) + " ")]), _vm.orderInfo.sign_time1 ? _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v(" " + _vm._s(_vm.orderInfo.sign_mapname1 || '-') + " "), _c('span', {
    staticClass: "content-tag font-size-h4-normal",
    class: {
      'content-tag-abnormal': _vm.orderInfo.signnormal1 !== 1
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.orderInfo.signnormal1 == 1 ? i18n.tc("621") : i18n.tc("8")))])])]) : _vm._e()]), _vm._l(_vm.orderServiceNodes, function (item, index) {
    return _c(__unplugin_components_4, {
      key: index,
      attrs: {
        "dash": _vm.orderInfo.state >= 5 || index !== _vm.orderServiceNodes.length - 1
      }
    }, [_c('div', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(" " + _vm._s(item.node_tmpl_name) + " ")]), _c('div', {
      attrs: {
        "slot": "date"
      },
      slot: "date"
    }, [_vm._v(" " + _vm._s(item.create_time || i18n.tc("622")) + " ")]), _c('div', {
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_c(__unplugin_components_5, {
      attrs: {
        "extFields": _vm.serviceTreeMap[item.node_tmpl_id] || []
      }
    })], 1)]);
  }), _vm.orderInfo.state >= 5 ? _c(__unplugin_components_6, {
    attrs: {
      "dash": false
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(i18n.tc("545"))]), _c('div', {
    attrs: {
      "slot": "date"
    },
    slot: "date"
  }, [_vm._v(" " + _vm._s(_vm.orderInfo.sign_time2) + " ")]), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v(" " + _vm._s(_vm.orderInfo.sign_mapname2 || '-') + " "), _c('span', {
    staticClass: "content-tag font-size-h4-normal",
    class: {
      'content-tag-abnormal': _vm.orderInfo.signnormal2 !== 1
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.orderInfo.signnormal2 == 1 ? i18n.tc("621") : i18n.tc("8")))])])])]) : _vm._e()], 2) : _vm._e()] : _vm._e(), _c('actionsheet', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }],
    attrs: {
      "menus": _vm.menus,
      "show-cancel": ""
    },
    on: {
      "on-click-menu": _vm.clickMenus
    },
    model: {
      value: _vm.show,
      callback: function ($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  })], 2)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };